import { render, staticRenderFns } from "./svgSoroush.vue?vue&type=template&id=18ae0867&scoped=true"
import script from "./svgSoroush.vue?vue&type=script&lang=js"
export * from "./svgSoroush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae0867",
  null
  
)

export default component.exports